export const NEW_USER_MODAL_TEXT =
  'Digilooms helps you create and curate a legacy of your precious memories. Sign up or Find out more here. Or download the App.';

export const MEMORIES_LOADER_SIZE = 30;
